export interface ResolvedStyle {
  fontFamily: string;
  fontSizePt: number;
  openTypeFeatures: Record<string, boolean>;
  fontWeight: number;
  fontStyle: 'normal' | 'italic';
  lineHeight: number; // multiple (unitless) or absolute depending on usage; default provided
  colorHex: string;
}

export interface CharacterStyleInput {
  fontFamily: string;
  fontSizePt: number;
  fontWeight?: number;
  fontStyle?: 'normal' | 'italic';
  colorHex?: string;
  openTypeFeatures?: Record<string, boolean>;
}

export function resolveFont(style: CharacterStyleInput): ResolvedStyle {
  const defaultOT: Record<string, boolean> = { liga: true, smcp: false };
  const ot = { ...defaultOT, ...(style.openTypeFeatures || {}) };
  return {
    fontFamily: style.fontFamily,
    fontSizePt: style.fontSizePt,
    fontWeight: style.fontWeight ?? 400,
    fontStyle: style.fontStyle ?? 'normal',
    colorHex: style.colorHex ?? '#000000',
    lineHeight: 1.5, // default; may be refined by FontMetrics
    openTypeFeatures: ot,
  };
}


